var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control ds-form-item ds-audit-state",
      class: _vm.getCss,
    },
    [
      _vm.simple && _vm.readOnly && !_vm.isDesign
        ? [
            _c(
              "DsfTextProxy",
              _vm._b(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isVisible,
                      expression: "isVisible",
                    },
                  ],
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "DsfTextProxy",
                _vm._self.$props,
                false
              )
            ),
            _vm.value != ""
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isVisible,
                        expression: "isVisible",
                      },
                    ],
                  },
                  [_vm._v(_vm._s(_vm.append))]
                )
              : _vm._e(),
            _vm._t("error", function () {
              return [
                _vm.errors.length > 0
                  ? _c("div", { staticClass: "ds-error-text" }, [
                      _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                    ])
                  : _vm._e(),
              ]
            }),
          ]
        : [
            _vm.showLabel
              ? _c(
                  "DsfFieldLabel",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isVisible,
                        expression: "isVisible",
                      },
                    ],
                    style: _vm.getLabelWidthStyle(),
                    attrs: {
                      mode: _vm.showDataCaptionMode,
                      "show-icon": _vm.showDataCaptionIcon,
                      trigger: _vm.showDataCaptionTrigger,
                      "data-caption": _vm.dataCapion,
                      "is-design": _vm.isDesign,
                      owner: _vm._self,
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t(_vm.label)) + " ")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isVisible,
                    expression: "isVisible",
                  },
                ],
                staticClass: "ds-form-block",
                style: _vm.getFormItemBlockMarginLeft(),
              },
              [
                _vm.readOnly
                  ? _c(
                      "div",
                      { staticClass: "ds-form-readonly" },
                      [
                        _c(
                          "DsfTextProxy",
                          _vm._b(
                            {
                              attrs: { "show-label": false },
                              model: {
                                value: _vm.value,
                                callback: function ($$v) {
                                  _vm.value = $$v
                                },
                                expression: "value",
                              },
                            },
                            "DsfTextProxy",
                            _vm._self.$props,
                            false
                          )
                        ),
                        _vm.value != ""
                          ? _c("span", [_vm._v(_vm._s(_vm.append))])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._t("error", function () {
                  return [
                    _vm.errors.length > 0
                      ? _c("div", { staticClass: "ds-error-text" }, [
                          _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showOpenBtn,
                    expression: "showOpenBtn",
                  },
                  { name: "drag", rawName: "v-drag" },
                ],
                staticClass: "ds-audit-state-fixed-btn",
                on: { click: _vm.showDrawerOpen },
              },
              [_vm._v(" 审 ")]
            ),
            _c(
              "el-drawer",
              {
                attrs: {
                  "append-to-body": "",
                  title: "审核信息",
                  visible: _vm.drawerOpen,
                  direction: "rtl",
                  "destroy-on-close": true,
                  size: "40%",
                  "custom-class": "ds-audit-state-drawer",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.drawerOpen = $event
                  },
                  close: _vm.drawerClose,
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showOpenBtn,
                        expression: "showOpenBtn",
                      },
                    ],
                    staticClass: "ds-audit-state-drawer-list",
                  },
                  [
                    _vm.mandatoryErrorList.length
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "ds-audit-state-drawer-title",
                              attrs: { type: "mandatory" },
                            },
                            [_c("span", [_vm._v("强制型")])]
                          ),
                          _vm._l(
                            _vm.mandatoryErrorList,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: "mandatory" + index,
                                  staticClass: "ds-audit-state-drawer-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.errorClick(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ds-audit-state-drawer-top",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ds-audit-state-drawer-item-label",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getSubTableLabel(item)
                                              ) +
                                              _vm._s(item.label) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " ：" + _vm._s(item.message) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                        ]
                      : _vm._e(),
                    _vm.verifyErrorList.length
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "ds-audit-state-drawer-title",
                              attrs: { type: "verify" },
                            },
                            [_c("span", [_vm._v("核实型")])]
                          ),
                          _vm._l(_vm.verifyErrorList, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: "verify" + index,
                                staticClass: "ds-audit-state-drawer-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.errorClick(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "ds-audit-state-drawer-top" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ds-audit-state-drawer-item-label",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getSubTableLabel(item)) +
                                            _vm._s(item.label) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" ：" + _vm._s(item.message) + " "),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ds-audit-state-drawer-remark",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ds-audit-state-drawer-remark-label",
                                      },
                                      [_vm._v("说明：")]
                                    ),
                                    _c("el-input", {
                                      staticClass:
                                        "ds-audit-state-drawer-remark-input",
                                      attrs: {
                                        value: item.remark,
                                        size: "mini",
                                        placeholder: "请输入备注",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.remarkInput($event, item)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ]
                      : _vm._e(),
                    _vm.ignoreErrorList.length
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "ds-audit-state-drawer-title",
                              attrs: { type: "ignore" },
                            },
                            [_c("span", [_vm._v("忽略型")])]
                          ),
                          _vm._l(_vm.ignoreErrorList, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: "ignore" + index,
                                staticClass: "ds-audit-state-drawer-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.errorClick(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "ds-audit-state-drawer-top" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ds-audit-state-drawer-item-label",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getSubTableLabel(item)) +
                                            _vm._s(item.label) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" ：" + _vm._s(item.message) + " "),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showOpenBtn,
                        expression: "!showOpenBtn",
                      },
                    ],
                    staticStyle: { "text-align": "center" },
                  },
                  [_vm._v("无错误信息")]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSaveBtn,
                        expression: "showSaveBtn",
                      },
                    ],
                    staticClass: "ds-audit-state-drawer-btns",
                  },
                  [
                    _c("dsf-button", { on: { click: _vm.save } }, [
                      _vm._v("确认保存"),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }